import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_SUBSCRIPTIONSTATUSES = 'GET_SUBSCRIPTIONSTATUSES';
export const SELECT_SUBSCRIPTIONSTATUSES = 'SELECT_SUBSCRIPTIONSTATUSES';
export const GET_SUBSCRIPTIONPACKAGESS = 'GET_SUBSCRIPTIONPACKAGESS';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchSubscriptionStatuses() {
    return function(dispatch) {
		dispatch(loader(true));
		axios
            .get(`${ROOT_API_URL}/ManageMagazineSubscriptionStatus/GetMagazineSubscriptionStatuses`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_SUBSCRIPTIONSTATUSES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function fetchSubscriptionPackages() {
    return function (dispatch) {
        dispatch(loader(true));
        axios
            .get(`${ROOT_API_URL}/ManageMagazineSubscriptionStatus/GetMagazineSubscriptionPackages`, { headers: auth.authHeader() })
            .then((response) => {
                dispatch({
                    type: GET_SUBSCRIPTIONPACKAGESS,
                    payload: response.data
                });
                dispatch(loader(false));
            })
            .catch((response) => {
                var err = response && response.data ? response.data.message : 'Network Connection Error';
                dispatch(loader(false));
                dispatch(toastr(true, err, errorColor));
            });
    };
}

export function selectSubscriptionStatus(selectedSubscriptionStatusObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_SUBSCRIPTIONSTATUSES,
            selectedSubscriptionStatus: selectedSubscriptionStatusObject
        })
    }
}


